export interface IValidationState {
    validationRules: Record<string, string>;
    allowedFileTypes: Array<string>;
}

export const state: IValidationState = {
    validationRules: {},
    allowedFileTypes: []
};
